import { useMemo } from "react";
import useAppSelector from "@/core/helpers/useAppSelector";
import {
  HEAD_OVERLAY,
  MAKEUP_OVERLAY_COLORS,
} from "@/domains/createCharacter/constants/headOverlay";
import { headOverlaySelector } from "@/domains/createCharacter/slice";
import CreateCharacterColorSwitcher from "@/domains/createCharacter/components/CreateCharacterColorSwitcher";
import CreateCharacterRange from "@/domains/createCharacter/components/CreateCharacterRange";
import CreateCharacterVariantSelect from "@/domains/createCharacter/components/CreateCharacterVariantSelect";

type Props = {
  feature: string;
  onChange: (value: object) => void;
};

export default function CreateCharacterSetContainer({ feature, onChange }: Props) {
  const headOverlay = useAppSelector(headOverlaySelector);
  const headOverlayFeature = useMemo(() => headOverlay[feature], [headOverlay, feature]);

  return (
    <div className="grid gap-2 group/row">
      <div className="text-lg font-bold mb-1 mt-1.5 flex justify-between items-center group-first/row:mt-0">
        {HEAD_OVERLAY[feature].localization}
      </div>
      <CreateCharacterVariantSelect
        value={headOverlayFeature.index}
        variants={[
          HEAD_OVERLAY[feature].default,
          ...new Array(HEAD_OVERLAY[feature].max).fill(null).map((_, v) => v),
        ]}
        label="Вариант"
        onChange={(index) => {
          onChange({ [feature]: { ...headOverlayFeature, index } });
        }}
        valueDefault={255}
      />
      <CreateCharacterRange
        min={0}
        label="Непрозрачность"
        value={headOverlayFeature.opacity}
        onChange={(opacity) => {
          onChange({ [feature]: { ...headOverlayFeature, opacity } });
        }}
      />
      <CreateCharacterColorSwitcher
        label="Основной цвет"
        variants={MAKEUP_OVERLAY_COLORS}
        value={headOverlayFeature.firstColor}
        onChange={(firstColor) => {
          onChange({ [feature]: { ...headOverlayFeature, firstColor } });
        }}
      />
      <CreateCharacterColorSwitcher
        label="Доп. цвет"
        variants={MAKEUP_OVERLAY_COLORS}
        value={headOverlayFeature.secondColor}
        onChange={(secondColor) => {
          onChange({ [feature]: { ...headOverlayFeature, secondColor } });
        }}
      />
    </div>
  );
}
